import React from "react";
import "./ImageSkeleton.scss";
import berryIcon from "../assets/images/berryIcon.png";

const ImageSkeleton = ({ className = "", width = "100%", height = "100%" }) => {
  return (
    <div className={`image-skeleton ${className}`} style={{ width, height }}>
      <div className="skeleton-shimmer">
        <img className="__logo" alt="maple grove logo" src={berryIcon} />
      </div>
    </div>
  );
};

export default ImageSkeleton;
